export const leadHasHumanOwnership = (lead) => {
  if (!lead) return false;
  const responsavel = String(lead.responsavel || "").trim().toLowerCase();
  const consultantId = Number(lead.consultantId ?? lead.consultorAtual ?? lead.assignedConsultantId);
  const handoff = lead.aurora_handoff === true
    || lead.aurora_handoff === 1
    || String(lead.aurora_handoff).toLowerCase() === "true"
    || lead.qualification_human_active === true
    || lead.qualification_human_active === 1
    || String(lead.qualification_human_active).toLowerCase() === "true"
    || ["em_atendimento_consultor", "atendimento_consultor"].includes(String(lead.status || "").toLowerCase());
  return (Number.isFinite(consultantId) && consultantId > 0)
    || handoff
    || (responsavel !== "" && responsavel !== "aurora" && responsavel !== "bot");
};

export const leadIsAuroraActive = (lead) => !leadHasHumanOwnership(lead);

// `responsavel` ainda pode vir como "aurora" em registros antigos mesmo depois
// de consultantId/handoff humano terem sido gravados. A UI deve sempre derivar
// o modo atual da posse efetiva, não desse campo legado isolado.
export const leadResponsibleMode = (lead) =>
  leadHasHumanOwnership(lead) ? "consultor" : "aurora";